<template>
  <Grid gtc="1fr auto 1fr" class="evaluations">
    <div class="general-evaluation">
      <div class="text-subtitle-2 text-secondary-2">General evaluation</div>

      <Grid gtc="auto 1fr" gap="var(--r-space-xl)" align-items="center" class="q-mt-xxl">
        <SliderSection
          v-model="evaluation.general_form.price_satisfaction.value"
          :label="evaluation.general_form.price_satisfaction.label"
        />
        <SliderSection
          v-model="evaluation.general_form.usage_satisfaction.value"
          :label="evaluation.general_form.usage_satisfaction.label"
        />
        <SliderSection
          v-model="evaluation.general_form.content_satisfaction.value"
          :label="evaluation.general_form.content_satisfaction.label"
        />
        <SliderSection
          v-model="evaluation.general_form.recommendation.value"
          :label="evaluation.general_form.recommendation.label"
        />
      </Grid>

      <div class="textarea q-mt-md">
        <div class="text-body-3 text-secondary-1">{{ evaluation.general_form.note.label }}</div>
        <q-input
          v-model="evaluation.general_form.note.value"
          bg-color="white"
          borderless
          type="textarea"
          class="textarea-input"
        />
      </div>
    </div>

    <div class="vertical-line"></div>

    <div class="evaluation-form q-mb-sm">
      <CustomFormRenderer
        :key="evaluation.id"
        :form="evaluation.custom_form"
        class="custom-form-rerender"
        @input="evaluation.custom_form = $event"
      >
        <template #header-actions>
          <RBtn type="link" :to="`/forms/${evaluation.custom_form.form_id}`" class="q-mb-lg">edit</RBtn>
        </template>

        <template #no-form>
          <Grid
            justify-content="center"
            align-items="center"
            align-content="center"
            justify-items="center"
            class="full-height"
          >
            <NoData />
            <span>There are no forms created yet</span>
            <RBtn type="link" :to="{ name: 'forms' }">Create custom form</RBtn>
          </Grid>
        </template>
      </CustomFormRenderer>
    </div>
  </Grid>
</template>

<script>
// Components
import CustomFormRenderer from '@components/lm-blocks/CustomFormRenderer'
import NoData from '@/reusable/svg-icons/NoData'
import SliderSection from './SliderSection'

export default {
  components: {
    CustomFormRenderer,
    NoData,
    SliderSection
  },

  props: {
    evaluation: Object
  }
}
</script>

<style lang="scss" scoped>
.evaluations {
  .vertical-line {
    width: 1px;
    background: var(--r-white-5);
    margin: 0 var(--r-space-xl);
  }

  .textarea {
    grid-column: span 2;

    .textarea-input {
      border: 1px solid var(--r-white-5);
      border-radius: var(--r-space-xs);

      ::v-deep textarea {
        resize: none;
        padding: calc(var(--r-space-xs) + var(--r-space-sm));
      }
    }
  }
}
</style>
